import React, { ReactElement } from "react";
import { childrenNodeType } from "../../../types";

// Images
import footerIconBlue from "../../../assets/images/remote-meeting-icon-blue.png";

// Styles
import "./authPage.scss";

import Image from "../../../components/image/image.component";

import MultiLanguage from "../../../components/global/multiLanguage/multiLanguage";
import { useSelector, shallowEqual } from "react-redux";

const AuthPageLayout = ({ children }: childrenNodeType): ReactElement => {
  const { generalSettings } = useSelector(
    ({ generalSettings }) => ({ generalSettings }),
    shallowEqual
  );

  return (
    <main id="tm__wrapper" className="flex-fill position-relative">
      <div id="tm__autorize" className="d-flex justify-content-center h-100">
        <div className="tm__autorize-container d-flex flex-column">
          <div className="d-flex flex-1 flex-column justify-content-center">
            <div className="d-flex justify-content-center mb-5">
              <a className="d-flex navbar-brand m-0" href="index.html">
                <Image
                  title={generalSettings?.clientName}
                  path={
                    !!generalSettings?.clientAuthBanner
                      ? generalSettings?.clientAuthBanner
                      : generalSettings?.clientLogo
                  }
                  width="100%"
                />
              </a>
            </div>
            {children}
          </div>
          <div className="d-flex flex-wrap justify-content-center">
            <div className="d-flex flex-fill align-items-center justify-content-between">
              <a href="index.html">
                <img src={footerIconBlue} alt="" width={50} />
              </a>
              <ul className="d-flex list-style-none p-0 m-0">
                <li className="d-flex align-items-center">
                  <a className="fs-8 text-secondary" href="#">
                    Privacy Policy
                  </a>
                </li>
                <li className="d-flex align-items-center">
                  <a className="fs-8 ms-3 text-secondary" href="#">
                    Terms of Service
                  </a>
                </li>
                <li className="d-flex align-items-center">
                  <a className="fs-8 ms-3 text-secondary" href="#">
                    Legal
                  </a>
                </li>
              </ul>
            </div>
            <div className="d-flex align-items-center ms-lg-3">
              <MultiLanguage></MultiLanguage>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AuthPageLayout;
